import { createSelector } from 'reselect';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import { ValueOf } from '../../globalTypes';
import { GlobalState } from '../../reducers';
import * as globalConstants from '../../constants';
import { selectors as testConfigurationSelectors } from '../testConfiguration';
import { utils as mobileAppSelectionUtils } from '../mobileAppSelection';

const sessionCommonSelector = (state: GlobalState) => state.apps.manual.sessionCommon;

const remoteTestNameSelector = createSelector(
  [sessionCommonSelector],
  (sessionCommon) => (
    sessionCommon.currentTest.name
  ),
);

const defaultTestNameSelector = createSelector([
  testConfigurationSelectors.testTypeSelector,
  testConfigurationSelectors.mobileAppConfigurationSelector,
  testConfigurationSelectors.urlSelector,
],
(
  testType: ValueOf<typeof globalConstants.CONFIGURATION_TEST_TYPES>,
  currentSelectedFile: appStorageRecords.AppStorageFile | null,
  url: string | null,
) => {
  const isAppTest = testType === globalConstants.CONFIGURATION_TEST_TYPES.APP;
  const defaultTestName = isAppTest ?
    mobileAppSelectionUtils.buildAppInfoString(currentSelectedFile) :
    url;

  return defaultTestName ?? '';
});

const testIdSelector = createSelector(
  [sessionCommonSelector],
  (sessionCommon) => (
    sessionCommon.currentTest.id
  ),
);

export default {
  defaultTestNameSelector,
  remoteTestNameSelector,
  testIdSelector,
};
